module.exports = __webpack_public_path__ + "static/media/05ю111.f1e52559.webp";